import Axios from "axios"
import type I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse"
import AxiosConfig from "src/utilities/AxiosConfig"

const GetLeaseActionableApprovalCount = async (): Promise<number> => {
	try {
		const response = await Axios.get<I_BaseAPIResponse<number>>(
			`${process.env.REACT_APP_API_URL}/api/fleet/leases/count`,
			AxiosConfig.configValue("min"),
		)
		return response.data.HasError ? 0 : response.data.Data
	} catch (error) {
		console.error("GetLeaseActionableApprovalCount failed: ", error)
		return 0
	}
}

export default GetLeaseActionableApprovalCount
